import { handleAuthorization, handleOkResponseJson, apiFetch } from "./handlers"
import { obterToken } from "./loginService"
import { abrirBlobPdf, fecharJanelaPdf } from "./pdfHelper"
import * as axios from 'axios';

export default {
    obterFornecedoresAsync,
	enviarFornecedorAsync,
	editarFornecedorAsync,
	buscarCepAsync,
	downloadLista,
	obterPdf,
	getPdf
}

export const obterFornecedoresAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Fornecedor/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarFornecedorAsync = async (nome, nomeFantasia, cpf_cnpj, inscricaoEstadual, contato, celular, telefone, ramal, emails, cep, endereco, numero, complemento, bairro, cidade, uf) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ nome, nomeFantasia, cpf_cnpj, inscricaoEstadual, contato, celular, telefone, ramal, emails, cep, endereco, numero, complemento, bairro, cidade, uf })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/Fornecedor`, requestOptions);
}

export const editarFornecedorAsync = async (id, nome, nomeFantasia, cpf_Cnpj, inscricaoEstadual, contato, celular, telefone, ramal, emails, cep, endereco, numero, complemento, bairro, cidade, uf, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, nome, nomeFantasia, cpf_Cnpj, inscricaoEstadual, contato, celular, telefone, ramal, emails, cep, endereco, numero, complemento, bairro, cidade, uf, ativo })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/Fornecedor/atualizar`, requestOptions);
}

export const buscarCepAsync = async (cep) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() }
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Endereco/consultaCep/` + cep, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export function downloadLista() {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/Fornecedor/downloadFornecedores`,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			return { status: false };
		})
			.then((response) => {
				if (response.status === false)
					return response;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'fornecedores' + '.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			});
	} catch (e) {
		throw e;
	}
}

export function obterPdf(id, nome, nomeFantasia, cpf_Cnpj, inscricaoEstadual, contato, celular, telefone, ramal, email, cep, endereco, numero, complemento, bairro, cidade, uf, ativo, janelaPdf = null) {
	try {
		var dataCadastro = '2021-04-11T19:25:34.923Z';
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/Fornecedor/obterPdf`,
			method: 'POST',
			dataType: 'json',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
			data: JSON.stringify({ id, nome, nomeFantasia, cpf_Cnpj, inscricaoEstadual, contato, celular, telefone, ramal, email, cep, endereco, numero, complemento, bairro, cidade, uf, ativo, dataCadastro }),
		}).catch(() => {
			fecharJanelaPdf(janelaPdf);
			return { status: false };
		})
			.then((response) => {
				if (response.status === false) {
					fecharJanelaPdf(janelaPdf);
					return response;
				}
				abrirBlobPdf(response.data, janelaPdf);
			});
	} catch (e) {
		fecharJanelaPdf(janelaPdf);
		throw e;
	}
}


export function getPdf(id, janelaPdf = null) {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/Fornecedor/downloadPdf/` + id,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			fecharJanelaPdf(janelaPdf);
			return { status: false };
		})
			.then((response) => {
				if (response.status === false) {
					fecharJanelaPdf(janelaPdf);
					return response;
				}
				abrirBlobPdf(response.data, janelaPdf);
			});
	} catch (e) {
		fecharJanelaPdf(janelaPdf);
		throw e;
	}
}
